export default {
  title: "Horaires d'ouverture",
  headers: {
    edit_time: "Modifier l'horaire",
    create_time: 'Créer un horaire',
  },
  labels: {
    select_all: 'Tout sélectionner',
    timezone: 'Fuseau horaire',
  },
  fields: {
    selected_days: {
      label: 'Jours sélectionnés',
    },
    opening_time: {
      label: "Heure d'ouverture",
    },
    closing_time: {
      label: 'Heure de fermeture',
    },
  },
  columns: {
    days: 'Jours',
    time: 'Heure',
  },
  buttons: {
    add_opening_time: "Ajouter un horaire d'ouverture",
    add: 'Ajouter',
    cancel: 'Annuler',
    save: 'Enregistrer',
    close: 'Fermer',
    delete: 'Supprimer',
    sync_from_online_shop: 'Synchroniser depuis la boutique en ligne',
  },
  projects: {
    online_shop: 'Boutique en ligne',
    reservations: 'Réservations',
    storefront: 'Vitrine',
    not_set_up: '{{project}} (non configuré pour cet établissement)',
  },
  feedback: {
    missing_info: 'Informations manquantes',
  },
  toasts: {
    saving_success: 'Enregistré avec succès',
    saving_error: "Échec de l'enregistrement. Veuillez vérifier vos informations et réessayer.",
    sync_success: 'Synchronisé avec succès',
    sync_error: 'Échec de la synchronisation des horaires depuis la boutique en ligne. Veuillez réessayer.',
    hours_required: "Les horaires d'ouverture sont obligatoires. Modifiez les horaires existants.",
    not_copied: {
      reservations: {
        not_set_up:
          "Les réservations n'ont pas été mises à jour : elles ne sont pas encore configurées pour cet établissement. L'onglet Réservations explique pourquoi.",
        not_matched:
          "Les réservations n'ont pas été mises à jour : le créneau {{time}} n'y existe pas. Vérifiez les horaires dans l'onglet Réservations.",
        failed:
          "Les réservations n'ont pas pu être mises à jour. Utilisez « Synchroniser depuis la boutique en ligne » dans l'onglet Réservations.",
      },
      storefront: {
        not_set_up: "La vitrine n'a pas été mise à jour : aucune vitrine trouvée pour cet établissement.",
        not_matched:
          "La vitrine n'a pas été mise à jour : le créneau {{time}} n'y existe pas. Vérifiez les horaires dans l'onglet Vitrine.",
        failed:
          "La vitrine n'a pas pu être mise à jour. Utilisez « Synchroniser depuis la boutique en ligne » dans l'onglet Vitrine.",
      },
    },
  },
  modals: {
    timezone: {
      form: {
        timezone: {
          label: 'Fuseau horaire',
        },
      },
      toasts: {
        error: 'Échec de la mise à jour du fuseau horaire',
      },
    },
  },
};
